export const mapHeroSectionData = (response) => {
  const BE_DATA = response;
  const data = {};

  data.title = BE_DATA?.hero?.title;
  data.features = BE_DATA?.hero?.features;

  return data;
};

export const mapHealthConditionData = (response) => {
  const BE_DATA = response;
  const data = {};

  data.count = "1";
  data.title = BE_DATA?.section_headers?.health_condition_section?.title;
  data.subtitle = BE_DATA?.section_headers?.health_condition_section?.sub_title;
  data.conditions = BE_DATA?.health_conditions;

  return data;
};
export const mapPackageData = (response) => {
  const BE_DATA = response;
  const data = {};

  data.count = "2";
  data.title = BE_DATA?.section_headers?.package_section?.title;

  return data;
};
export const mapPartnerData = (response) => {
  const BE_DATA = response;
  const data = {};

  data.count = "3";
  data.title = BE_DATA?.section_headers?.partner_section?.title;
  data.subtitle = BE_DATA?.section_headers?.partner_section?.sub_title;

  return data;
};
export const mapFormData = (response, selectedPartner) => {
  const SELECTED_PARTNER = selectedPartner;
  const BE_DATA = response;
  const formData = BE_DATA?.form_data;
  const data = {};

  data.count = "4";
  data.title = "Book the Test";
  data.forms = {
    partnerImage: formData?.image,
    title: formData?.title,
    subTitle: formData?.sub_title,
    whatsapp: formData?.contact_number_text,
    whatsappTitle: formData?.bottom_title,
    callUs: formData?.bottom_sub_title,
    contact: formData?.contact_number_text_secondary,
    partnerLogo: SELECTED_PARTNER?.logo,
    partnerName: SELECTED_PARTNER?.title,
    partnerSlug: SELECTED_PARTNER?.slug,
    ctaTitle: formData?.button_text,
    successImage: formData?.image,
    submissionTitle: formData?.submission_title,
    submissionSubtitle: formData?.submission_subtitle,
  };

  return data;
};
